import React, { useContext, useEffect, useRef, useState } from "react";
import Dropdown from "../../Genericos/Dropdown/Dropdown";
import DatePicker from "../../Genericos/DatePicker/DatePicker";
import { PortalContext } from "../../../context/Provider";
import {
  wsGetVerificaEstudios,
  wsPostTurnosEstudios,
  logoutEstudiosTurnos,
  wsPostCalulaMinutos,
  wsPostTurnosKinesio,
} from "../../../context/Actions/turnos/estudioTurnos";
import fechaTurnoFormat from "../../../../global/utils/fechaTurnoFormat";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { useHistory } from "react-router";
import {
  showModal,
  hideModal,
  hideModalAction,
} from "../../../context/Actions/modal/modal";
import {
  editaTurnosDisponibles,
  resetFiltrosDisponibles,
  setFechaTurno,
} from "../../../context/Actions/turnos/turnosDisponibles";

import TurnosAgregados from "../TurnosAgregados/TurnosAgregados";
import InformacionBuscador from "../../Genericos/InformacionBuscador/InformacionBuscador";
import { IonSpinner } from "@ionic/react";
import "./BuscadorEstudio.css";
import { dropdownFamiliares } from "../ListaFamiliaresDropdown/ListaFamiliaresDropdown";
import { GlobalContext } from "../../../../global/context/Provider";
import PresentismoBox from "../PresentismoBox/PresentismoBox";
import {
  resetPresentismo,
  wsGetPresentismoDetalle,
} from "_+_Portal/context/Actions/presentismo/presentismo";
import DropdownV2 from "_+_Portal/components/Genericos/DropdownV2/DropdownV2";
import { resetOrdenDigitalEstudio } from "_+_Portal/context/Actions/ordenDigital/ordenDigital";

const BuscadorEstudio2 = ({
  listaDeterminaciones,
  onChangeMultitabMobile,
  buscadorTurnos,
  setLoading,
}) => {
  const history = useHistory();
  const {
    estudioGrupoState,
    estudioTurnosDispatch,
    estudioTurnosState,
    modalDispatch,
    turnosDisponiblesDispatch,
    turnosDisponiblesState,
    listaFamiliaresState,
    selectDropDownState,
    textosState,
    presentismoDispatch,
    presentismoState,
    ordenDigitalState,
    ordenDigitalDispatch,
  } = useContext(PortalContext);

  // Cambio de contexto
  const { authState, toasterDispatch, configState } = useContext(GlobalContext);

  const hoy = new Date();
  const fechaLimte = new Date();
  const days = 90;
  fechaLimte.setDate(fechaLimte.getDate() + days);
  let accion = sessionStorage.getItem("accionHash");
  // Busca el dia de hoy para el datePicker
  const hoyDia = new Date();
  const noventaDiasDespues = new Date();
  noventaDiasDespues.setDate(noventaDiasDespues.getDate() + 90);

  const [idEstudio, setIdEstudio] = useState("");
  const [descEstudio, setDescEstudio] = useState("");
  const [leyendaCircuito, setLeyendaCircuito] = useState("");
  const [gruposMedico, setGruposMedico] = useState([]);
  const [fechaDeHoy, setFechaDeHoy] = useState();
  const [onChangeDate, setOnChangeDate] = useState(null);
  const [flgParticular, setFlgParticular] = useState(false);
  const [flgBusquedaDefault, setFlgBusquedaDefault] = useState(false);
  const [determinaciones, setDeterminaciones] = useState(listaDeterminaciones);
  const ordenGrupoMedProcessed = useRef(false);
  const [flgModal, setFlgModal] = useState(false);
  const [user, setUser] = useState(authState);
  const [errorDropdown, setErrorDropdown] = useState(false);
  const [flgDobleVerif, setFlgDobleVerif] = useState(false);
  const [OSAlternativa, setOSAlternativa] = useState(false);

  const [dtoBusqEstudioDefault, setDtoBusqEstudioDefault] = useState({
    amamantando: false,
    conContraste: false, ////lo obtengo de seleccionar el item especialidad o estudio
    contrasteReciente: false,
    diabeticoHipertenso: false,
    embarazada: false,
    fechaDesde: fechaDeHoy, //fecha esta en datepicker
    GruposMedico: [
      {
        Id: idEstudio,
        Descripcion: descEstudio,
        Particular: flgParticular,
      },
    ],
    idGrupoMedico: idEstudio, //lo obtengo de seleccionar el item especialidad o estudio
    idObraSocial: user.auth.data.paciente.obra_social,
    idPlan: user.auth.data.paciente.idplan,
    insRenal: false,
    marcapasos: false,
    operador: accion ? "BOT" : "",
    pag: 1200, //hardcodeado en angular
    particular: flgParticular,
    pesoSuperior: false,
    pesoSuperiorCritico: false,
    rec: 0, //harcodeado en angularionic
    videoAtencion: false, //lo lleno por con el checkbox
  });
  const [flgCalculaMins, setFlgCalculaMins] = useState(false);
  const [flgOrden, setFlgOrden] = useState(false);
  const [ordenesAgregadas, setOrdenesAgregadas] = useState([]);
  const [flgPushTurnosDisp, setFlgPushTurnosDisp] = useState(false);

  let dtoPOST = false;
  let config = localStorage.getItem("config");
  let bloqueoPresentismo = JSON.parse(config).opcBloqueoPresentismo;

  const configDropdown = {
    data: determinaciones,
    autoFocus: true,
    ordenPersonalizado: true,
    header: buscadorTurnos ? "" : "Buscá lo que necesites",
    headerColor: buscadorTurnos && "c-white",
    footer: gruposMedico.length > 0 ? "" : "Buscá un estudio o análisis",
    descripcion: "descripcion",
    placeholder: textosState.textos.data?.txtEstudios?.descripcion,
    placeHolderFontSize: 16,
    defaultValue: "tags",
    defaultValueParametro: "id",
    height: 38,
    cantidadItems: 10,
    maxlength: 100,
    error: errorDropdown,
    arrow: true,
    search: false,
    disabled: false,
    tooltip: false,
    showUp: true,
    regex: /^[a-zA-Z\s]+$/,
    masBuscados: configState.config.data.opcMasBuscados,
    buscarPorDefault: true,
  };

  //#region -------- functions --------
  const dissmiss = () => {
    hideModal()(modalDispatch);
    if (estudioTurnosState.estudioTurnos.data) {
      if (
        estudioTurnosState.estudioTurnos.data.continua &&
        estudioTurnosState.estudioTurnos.data.circuito === "KIN"
      ) {
        showModalKinesio();
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      }
    }
    resetPresentismo()(presentismoDispatch);
  };

  const volverAOrdenes = () => {
    resetOrdenDigitalEstudio()(ordenDigitalDispatch);
    history.push("/ordenesDigitales");
  };

  const dissmissPreparacion = (data, id, desc, circuito) => {
    if (data.continua && data.circuito === "KIN") {
      hideModalAction(() => showModalKinesio(id, desc, circuito))(
        modalDispatch
      );
      logoutEstudiosTurnos()(estudioTurnosDispatch);
    } else {
      hideModal()(modalDispatch);
      // borro la data en el dissmiss de la preparacion ya que,
      // si vuelvo a buscar kinesio, no levanta el modal de part.
      if (ordenDigitalState.ordenDigital.altaTurno !== null) {
        setFlgOrden(true);
      }
    }
    logoutEstudiosTurnos()(estudioTurnosDispatch);
  };

  const onChangeDatePicker = (e) => {
    setOnChangeDate(e);
    setFechaTurno(e)(turnosDisponiblesDispatch);
  };

  const onChangeBuscador = (e) => {
    setOSAlternativa(false);
    if (e !== "") {
      if (
        (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
          ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
              .paciente.ausentismo.rankingPracticas === "Rojo"
          : authState.auth.data.paciente.ausentismo.rankingPracticas ===
            "Rojo") &&
        (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
          ? !selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
              .paciente.seguimiento
          : !authState.auth.data.paciente.seguimiento) &&
        bloqueoPresentismo === true
      ) {
        showModal(
          "Genericos/Mensaje/Mensaje",
          {
            titulo: <p className="rb24b">Atención</p>,
            textoNegrita: (
              <p className="rb18l">
                {textosState?.textos?.data?.msjBloqueoAusentismo?.descripcion}
              </p>
            ),
            dissmiss: dissmiss,
          },
          [
            {
              text: "Cerrar",
              clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
              accion: dissmiss,
            },
          ],
          "centro",
          true
        )(modalDispatch);
      } else {
        let arrxOrdenes = ordenesAgregadas ? [...ordenesAgregadas] : [];
        arrxOrdenes.push(e);
        setOrdenesAgregadas(arrxOrdenes);
        setIdEstudio(e.id);
        setDescEstudio(e.descripcion);
        setFlgParticular(false);
        setFlgModal(false);
        //me agrego la leyenda desde un principio, para los casos en que voy a part.
        setLeyendaCircuito(e.idCircuito);
        if (e.id !== null && e.id !== undefined) {
          // setDeshabilitoBusq(false);
          if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
            wsGetVerificaEstudios(
              e.id,
              false,
              false,
              selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                .id,
              false,
              (isCorrect, data) =>
                verificarEstudio(
                  isCorrect,
                  data,
                  e.id,
                  e.descripcion,
                  e.idCircuito
                )
            )(estudioTurnosDispatch);
          } else {
            wsGetVerificaEstudios(
              e.id,
              false,
              false,
              -1,
              false,
              (isCorrect, data) =>
                verificarEstudio(
                  isCorrect,
                  data,
                  e.id,
                  e.descripcion,
                  e.idCircuito
                )
            )(estudioTurnosDispatch);
          }
        }
      }
    } else if (e === "" && gruposMedico.length >= 1) {
      // setDeshabilitoBusq(false);
    } else {
      setIdEstudio("");
      setDescEstudio("");
      // setDeshabilitoBusq(true);
    }
  };

  const onBuscarTurnosClick = () => {
    if (leyendaCircuito === "KIN") {
      if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
        wsGetVerificaEstudios(
          idEstudio,
          false,
          false,
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
          false,
          (isCorrect, data) =>
            verificarEstudio(isCorrect, data, idEstudio, descEstudio)
        )(estudioTurnosDispatch);
      } else {
        wsGetVerificaEstudios(
          idEstudio,
          false,
          false,
          -1,
          false,
          (isCorrect, data) =>
            verificarEstudio(isCorrect, data, idEstudio, descEstudio)
        )(estudioTurnosDispatch);
      }
    } else {
      if (
        (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
          ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
              .paciente.ausentismo.rankingPracticas === "Rojo"
          : authState.auth.data.paciente.ausentismo.rankingPracticas ===
            "Rojo") &&
        (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
          ? !selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
              .paciente.seguimiento
          : !authState.auth.data.paciente.seguimiento) &&
        bloqueoPresentismo === true
      ) {
        showModal(
          "Genericos/Mensaje/Mensaje",
          {
            titulo: <p className="rb24b">Atención</p>,
            textoNegrita: (
              <p className="rb18l">
                {textosState?.textos?.data?.msjBloqueoAusentismo?.descripcion}
              </p>
            ),
            dissmiss: dissmiss,
          },
          [
            {
              text: "Cerrar",
              clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
              accion: dissmiss,
            },
          ],
          "centro",
          true
        )(modalDispatch);
      } else {
        if (idEstudio !== "") {
          if (!flgModal) {
            if (
              idEstudio !== "" &&
              Array.isArray(gruposMedico) &&
              !flgParticular &&
              gruposMedico.length > 0
            ) {
              // esta seria la que usamos ahora si el circuito es rmn o tomo
              if (leyendaCircuito !== "TOMO" && leyendaCircuito !== "RMN") {
                completarFormulario("", false);
              } else {
                modalDatosNecesarios();
              }
            } else if (idEstudio !== "" && flgBusquedaDefault) {
              //devuelve el dto de busquedadefault con la ultima fecha seleccionada
              let objBusqueda = verificaCambioFecha();
              objBusqueda = verificaOSAlternativa(objBusqueda);
              dtoPOST = objBusqueda;
              if (
                selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
              ) {
                wsPostTurnosEstudios(
                  objBusqueda,
                  selectDropDownState.selectDropDown.selectGlobal
                    .pacienteElegido.id,
                  (isCorrect, data) =>
                    verificarEstudio(isCorrect, data, idEstudio, descEstudio)
                )(estudioTurnosDispatch);
              } else {
                wsPostTurnosEstudios(objBusqueda, -1, (isCorrect, data) =>
                  verificarEstudio(isCorrect, data, idEstudio, descEstudio)
                )(estudioTurnosDispatch);
              }
              setFlgBusquedaDefault(false);
            } else {
              showToaster(
                {
                  texto: "Vuelva a comenzar la búsqueda",
                  tipo: "danger",
                },
                "centroArriba"
              )(toasterDispatch);
              setErrorDropdown(true);
            }
          } else {
            if (
              selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            ) {
              wsGetVerificaEstudios(
                idEstudio,
                false,
                false,
                selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                  .id,
                false,
                verificarEstudio
              )(estudioTurnosDispatch);
            } else {
              wsGetVerificaEstudios(
                idEstudio,
                false,
                false,
                -1,
                false,
                verificarEstudio
              )(estudioTurnosDispatch);
            }
          }
        } else {
          setErrorDropdown(true);
        }
      }
    }
  };

  const verificaCambioFecha = () => {
    let objBusqDefault = Object.assign({}, dtoBusqEstudioDefault);
    if (onChangeDate !== null) {
      objBusqDefault.fechaDesde = onChangeDate;
    } else if (
      turnosDisponiblesState.turnosDisponibles.turnosData.fechaSeleccionada
    ) {
      objBusqDefault.fechaDesde =
        turnosDisponiblesState.turnosDisponibles.turnosData.fechaSeleccionada;
    }
    return objBusqDefault;
  };

  const verificaOSAlternativa = (objBusqueda) => {
    if (OSAlternativa) {
      objBusqueda.OsAlternativa = true;
    } else {
      objBusqueda.OsAlternativa = false;
    }
    return objBusqueda;
  };

  const cancelaParticular = () => {
    dissmiss();
    logoutEstudiosTurnos()(estudioTurnosDispatch);
    setFlgParticular(false);
    setFlgCalculaMins(false);
  };

  const cancelaAlternativa = () => {
    dissmiss();
    logoutEstudiosTurnos()(estudioTurnosDispatch);
    setOSAlternativa(false);
  };

  const deterComoParticular = (origen, data, id, desc) => {
    if (origen === "osAlternativa") {
      setOSAlternativa(true);
    }
    dissmiss();
    setFlgModal(false);
    if (data.circuito !== "" && data.circuito !== "KIN") {
      setFlgParticular(false);
      const arrDeter = determinaciones.filter(
        (item) => item.idCircuito === data.circuito
      );
      setDeterminaciones(arrDeter);
      const arrGrupoMed = gruposMedico.filter((item) => item.id === id);
      if (typeof arrGrupoMed !== "undefined" && arrGrupoMed.length > 0) {
        showToaster(
          {
            texto: "Ya existe el turno seleccionado!",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      } else {
        setGruposMedico([
          ...gruposMedico,
          {
            id: id,
            descripcion: desc,
            particular: true,
          },
        ]);
        logoutEstudiosTurnos()(estudioTurnosDispatch);
        if (ordenDigitalState.ordenDigital.altaTurno !== null) {
          setFlgOrden(true);
        }
      }
    } else {
      logoutEstudiosTurnos()(estudioTurnosDispatch);
      setFlgDobleVerif(true);
    }
  };

  const modalDatosNecesarios = () => {
    if (leyendaCircuito === "RMN") {
      showModal(
        "Genericos/Preguntas/CircuitoReso",
        {
          titulo: "Datos necesarios",
          texto: "Porfavor, complete los siguientes datos para buscarle turnos",
          dissmiss:
            ordenDigitalState.ordenDigital.altaTurno !== null
              ? () => {
                  dissmiss();
                  volverAOrdenes();
                }
              : () => dissmiss(),
          completarFormulario: completarFormulario,
        },
        "centro"
      )(modalDispatch);
    } else {
      showModal(
        "Genericos/Preguntas/CircuitoTomo",
        {
          titulo: "Datos necesarios",
          texto: "Porfavor, complete los siguientes datos para buscarle turnos",
          dissmiss:
            ordenDigitalState.ordenDigital.altaTurno !== null
              ? () => {
                  dissmiss();
                  volverAOrdenes();
                }
              : () => dissmiss(),
          completarFormulario: completarFormulario,
        },
        "centro"
      )(modalDispatch);
    }
  };

  const showInfoBuscador = () => {
    // alert("Puede seguir buscando mas turnos del mismo tipo");
  };

  const modalParticular = (data, id, desc) => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "La obra social no cubre el estudio",
        textoNegrita: "¿Desea tomar el turno como particular?",
        texto: data?.mensaje
          ? data?.mensaje
          : "El estudio seleccionado no figura dentro de tu cobertura",
        dissmiss:
          ordenDigitalState.ordenDigital.altaTurno !== null
            ? () => {
                dissmiss();
                volverAOrdenes();
              }
            : dissmiss,
      },
      [
        {
          text: "Cancelar",
          clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
          accion:
            ordenDigitalState.ordenDigital.altaTurno !== null
              ? () => {
                  cancelaParticular();
                  volverAOrdenes();
                }
              : cancelaParticular,
        },
        {
          text: "Tomar como particular",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: () => deterComoParticular(false, data, id, desc),
        },
      ],
      "centro"
    )(modalDispatch);
  };

  const modalOSAlternativa = (data, id, desc) => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "La obra social no cubre el estudio",
        textoNegrita: "¿Deseás tomar el turno con tu obra social alternativa?",
        texto:
          estudioTurnosState.estudioTurnos.data?.mensaje !== ""
            ? estudioTurnosState.estudioTurnos.data.mensaje
            : "El estudio seleccionado no figura dentro de tu cobertura",
        dissmiss: dissmiss,
      },
      [
        {
          text: "Cancelar",
          clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
          accion: cancelaAlternativa,
        },
        {
          text: "Tomar con OS alternativa",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: () => deterComoParticular("osAlternativa", data, id, desc),
        },
      ],
      "centro"
    )(modalDispatch);
  };

  const modalAtencionSinTurnoPrevio = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "El estudio se realiza sin turno previo",
        textoNegrita: "Prueba",
        texto: "a Definir",
        dissmiss: dissmiss,
        danger: true,
      },
      [
        {
          text: "Salir",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: dissmiss,
        },
        {
          text: "Leer sobre turnos sin reserva",
          clase: "btn-Mensaje-1 rb16m bgc-latex30 c-white",
          accion: dissmiss,
        },
      ],
      "centro"
    )(modalDispatch);
  };

  const onClickHandlerCancelarEtiq = (e) => {
    const arr = gruposMedico.filter((item) => item.id !== e);
    setGruposMedico(arr);
    //vuelvo a setear la lista del dropdown original ya que sali del circuito.
    if (arr.length === 0) {
      const arrGrupoMed = estudioGrupoState.estudioGrupo.data.filter(
        (item) => item.sonPracticas === true && item.id > 0
      );
      setDeterminaciones(arrGrupoMed);
      setLeyendaCircuito("");
      setIdEstudio("");
      setDescEstudio("");
      // setDeshabilitoBusq(true);
    }
  };

  //funciones y logica Kinesio
  const showModalKinesio = (id, desc, circuito) => {
    //saco el domingo ya que no entra dentro de los dias.
    turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.diasKin.pop();
    showModal(
      "Turnos/FiltrosKinesio/FiltrosKinesio",
      {
        titulo: "Filtrar por dia y hora",
        dissmiss: dissmissKinesio,
        onChangeDatePicker: onChangeDatePicker,
        onHandleBuscarTurnosKin: (dias, rango) =>
          onHandleBuscarTurnosKin(dias, rango, id, desc, circuito),
        fecha: hoy,
      },
      [],
      "centro",
      true
    )(modalDispatch);
  };

  const dissmissKinesio = () => {
    resetFiltrosDisponibles()(turnosDisponiblesDispatch);
    hideModal()(modalDispatch);
  };

  const onHandleBuscarTurnosKin = (dias, rango, idEst, descEst, circuito) => {
    let auxDias = dias.filter(
      (item) => item.checked !== false && item.id !== 0
    );
    let auxKin = rango.filter(
      (item) => item.checked !== false && item.id !== 0
    );

    // // Filtrado provisorio de días
    if (dias[0]?.checked) {
      auxDias = dias.filter((item) => item.id !== 0);
    }

    // // Filtrado provisorio de rangoKinesio
    if (rango[0]?.checked) {
      auxKin = rango.filter((item) => item.id !== 0);
    }

    if (auxDias.length >= 3 && auxKin.length > 0) {
      auxDias = auxDias.map((array) => array.id);
      auxKin = auxKin.map((array) => array.rango);
      let config = localStorage.getItem("config");
      let sectorTurno = JSON.parse(config).sectorTurno;
      let objBusqueda = verificaCambioFecha();
      dtoPOST = objBusqueda;

      let dtoKin = {
        cantidad: 10,
        fechaDesde: onChangeDate !== null ? onChangeDate : fechaDeHoy,
        idGrupoMedico: idEst,
        listDias: auxDias,
        listHorario: auxKin,
        particular: flgParticular,
        sectorTurno: sectorTurno,
      };
      hideModal()(modalDispatch);
      if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
        wsPostTurnosKinesio(
          dtoKin,
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
          (isCorrect, data) =>
            verificarEstudio(
              isCorrect,
              data,
              idEst,
              descEst,
              circuito,
              null,
              dias,
              rango
            )
        )(estudioTurnosDispatch);
      } else {
        wsPostTurnosKinesio(dtoKin, -1, (isCorrect, data) =>
          verificarEstudio(
            isCorrect,
            data,
            idEst,
            descEst,
            circuito,
            null,
            dias,
            rango
          )
        )(estudioTurnosDispatch);
      }
    } else {
      showToaster(
        {
          texto: "Seleccione al menos 1 rango horario y 3 dias de la lista",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  const completarFormulario = (tipo, form) => {
    setLoading(true);
    dissmiss();
    if (flgCalculaMins) {
      let dtoCalculaMinutos = {
        ConContraste:
          tipo === ""
            ? false
            : tipo === "TOMO"
            ? form.conContraste
            : form.contraste,
        GruposMedico: gruposMedico,
        idObraSocial: user.auth.data.paciente.obra_social,
        idPlan: user.auth.data.paciente.idplan,
      };
      wsPostCalulaMinutos(dtoCalculaMinutos, (isCorrect, data) =>
        verificarEstudio(
          isCorrect,
          data,
          idEstudio,
          descEstudio,
          leyendaCircuito,
          form
        )
      )(estudioTurnosDispatch);
    } else {
      completarDtoBusquedaTurnos();
    }
    logoutEstudiosTurnos()(estudioTurnosDispatch);
  };

  const verificarEstudio = (
    isCorrect,
    data,
    id,
    desc,
    circ,
    formCircuito,
    dias,
    rango
  ) => {
    if (isCorrect) {
      if (
        (data.preparacion &&
          data.preparacion !== null &&
          data.preparacion !== "") ||
        data.requiereAutorizacion
      ) {
        showModal(
          "Turnos/Preparaciones/Preparaciones",
          {
            titulo:
              data.preparacion === null || data.preparacion === ""
                ? "Requiere Autorización"
                : "Preparaciones",
            preparacion: data.preparacion,
            autorizacion: data.requiereAutorizacion,
            dissmiss: () => dissmissPreparacion(data, id, desc, circ),
          },
          {},
          "centro",
          true
        )(modalDispatch);
      }

      if (data.calcularMinutos === true) {
        setFlgCalculaMins(true);
      } else if (data.calcularMinutos === false) {
        setFlgCalculaMins(false);
      }
      if (data.continua && data.calcularMinutos === false) {
        let particular = false;
        if (flgParticular) {
          particular = true;
        }
        //agregue los cambios de fecha si es anterior a buscar un turno.
        let fecha = fechaDeHoy;
        if (onChangeDate !== null) {
          fecha = onChangeDate;
        } else if (
          turnosDisponiblesState.turnosDisponibles.turnosData.fechaSeleccionada
        ) {
          fecha =
            turnosDisponiblesState.turnosDisponibles.turnosData
              .fechaSeleccionada;
        }
        let config = localStorage.getItem("config");
        let sectorTurno = JSON.parse(config).sectorTurno;

        setDtoBusqEstudioDefault({
          ...dtoBusqEstudioDefault,
          idGrupoMedico: id,
          fechaDesde: fecha,
          sectorTurno,
          GruposMedico: [
            {
              Id: id,
              Descripcion: desc,
              Particular: flgParticular,
            },
          ],
          particular: particular,
          idObraSocial: selectDropDownState.selectDropDown.selectGlobal
            .pacienteElegido
            ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                .paciente.obra_social
            : user.auth.data.paciente.obra_social,
          idPlan: selectDropDownState.selectDropDown.selectGlobal
            .pacienteElegido
            ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                .paciente.idplan
            : user.auth.data.paciente.idplan,
        });
        setFlgBusquedaDefault(true);
        //en el siguiente paso deberia preguntar primero por el circuito, y luego el push.
      } else if (
        data.turnos !== null &&
        data.turnos !== undefined &&
        data.turnos !== ""
      ) {
        const grupoMed =
          turnosDisponiblesState.turnosDisponibles.turnosData.GruposMedico;
        let particular = false;
        if (flgParticular) {
          particular = true;
        }
        let config = localStorage.getItem("config");
        let sectorTurno = JSON.parse(config).sectorTurno;
        editaTurnosDisponibles({
          ...turnosDisponiblesState.turnosDisponibles.turnosData,
          turnos: data.turnos,
          GruposMedico: dtoPOST.GruposMedico,
          particular: particular,
          idEstudio: Array.isArray(grupoMed) ? grupoMed[0].id : id,
          descEstudio: Array.isArray(grupoMed) ? grupoMed[0].descripcion : desc,
          descEspecialidad: null,
          fechaBusqueda: data.fechaBusqueda,
          sectorTurno,
          dtoBusqueda: dtoPOST,
          volverOrigen: "ESTUDIOS",
          proceso: "estudios",
          circuito: circ,
        })(turnosDisponiblesDispatch);
        setFlgPushTurnosDisp(true);
      } else if (data.continua && data.circuito !== "") {
        const arrDeter = determinaciones.filter(
          (item) => item.idCircuito === data.circuito
        );
        setDeterminaciones(arrDeter);
        const arrGrupoMed = gruposMedico.filter((item) => item.id === id);
        if (typeof arrGrupoMed !== "undefined" && arrGrupoMed.length > 0) {
          showToaster(
            {
              texto: "Ya existe el turno seleccionado!",
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
          logoutEstudiosTurnos()(estudioTurnosDispatch);
        } else {
          setGruposMedico([
            ...gruposMedico,
            {
              id: id,
              descripcion: desc,
              diasbusqueda: 0,
              filtroedadmax: 0,
              filtroedadmin: 0,
              idequivcontraste: 0,
              incidenciasmin: 0,
              omitirporminbusq: 0,
              videoatencion: false,
              particular: flgParticular,
            },
          ]);
          logoutEstudiosTurnos()(estudioTurnosDispatch);
        }
      } else if (
        data.minutos !== "" &&
        data.minutos !== undefined &&
        circ !== ""
      ) {
        // Una vez que estan calculados los minutos procedo a completar el dto
        // para realizar la busqueda de turnos
        completarDtoBusquedaTurnos(data, formCircuito);
      } else if (
        data !== undefined &&
        data !== null &&
        data !== false &&
        data !== "" &&
        Array.isArray(data)
      ) {
        let config = localStorage.getItem("config");
        let sectorTurno = JSON.parse(config).sectorTurno;
        editaTurnosDisponibles({
          ...turnosDisponiblesState.turnosDisponibles.turnosData,
          turnos: data,
          grupoMedico: null,
          particular: flgParticular,
          idEstudio: id,
          descEstudio: desc,
          descEspecialidad: null,
          fechaBusqueda: onChangeDate !== null ? onChangeDate : fechaDeHoy,
          dtoBusqueda: { ...dtoPOST, osAlternativa: OSAlternativa },
          sectorTurno,
          volverOrigen: "ESTUDIOS",
          circuito: circ,
          filtrosData: {
            ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
            diasKin: dias,
            rangoKinesio: rango,
          },
        })(turnosDisponiblesDispatch);
        history.push("/turnosDisponiblesKinesiologia");
      } else {
        if (data.codigo !== 0) {
          if (data.codigo === 9) {
            setFlgParticular(true);
            setFlgModal(true);
            modalParticular(data, id, desc);
            logoutEstudiosTurnos()(estudioTurnosDispatch);
          } else if (data.codigo === 10) {
            modalAtencionSinTurnoPrevio();
            logoutEstudiosTurnos()(estudioTurnosDispatch);
          } else if (data.codigo === 91) {
            setFlgParticular(false);
            setFlgModal(true);
            modalOSAlternativa(data, id, desc);
            logoutEstudiosTurnos()(estudioTurnosDispatch);
          } else if (data.codigo) {
            if (data.mensaje.length > 100) {
              showModal(
                "Genericos/Mensaje/Mensaje",
                {
                  titulo: <p className="rb18b">Información</p>,
                  textoNegrita: (
                    <p
                      className="rb18l"
                      dangerouslySetInnerHTML={{
                        __html: data.mensaje,
                      }}
                    ></p>
                  ),
                  danger: true,
                  dissmiss: dissmiss,
                },
                [
                  {
                    text: "Aceptar",
                    clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                    accion: dissmiss,
                  },
                ],
                "centro",
                true
              )(modalDispatch);
            } else {
              showToaster(
                {
                  texto: data.mensaje,
                  tipo: "danger",
                },
                "centroArriba"
              )(toasterDispatch);
            }
            logoutEstudiosTurnos()(estudioTurnosDispatch);
          }
        } else {
          showToaster(
            {
              texto: "No se hizo la consulta",
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
          logoutEstudiosTurnos()(estudioTurnosDispatch);
        }
      }
    } else {
      showToaster(
        {
          texto: data ? data : "Error al verificar estudio",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  const completarDtoBusquedaTurnos = (data, formCircuito) => {
    let dtoReso = null;
    let dtoTomo = null;
    let dtoCircuito = null;
    const grupoMed = data ? data.data : gruposMedico;

    let config = localStorage.getItem("config");
    let sectorTurno = JSON.parse(config).sectorTurno;
    if (leyendaCircuito === "RMN") {
      dtoReso = {
        amamantando: false,
        conContraste: formCircuito.contraste, ////lo obtengo de seleccionar el item especialidad o estudio
        contrasteReciente: false,
        diabeticoHipertenso: false,
        embarazada: false,
        fechaDesde: onChangeDate !== null ? onChangeDate : fechaDeHoy, //fecha esta en datepicker
        GruposMedico: grupoMed,
        idGrupoMedico: grupoMed[0].id, //lo obtengo de seleccionar el item especialidad o estudio
        idObraSocial: user.auth.data.paciente.obra_social, //lo obtengo del usuario
        idPlan: user.auth.data.paciente.idplan, // y aca
        insRenal: formCircuito.renal,
        marcapasos: formCircuito.marcaPasos,
        operador: accion ? "BOT" : "",
        minutosGrupo: data ? data.minutos : 0,
        pag: 1200, //hardcodeado en angular
        particular: grupoMed[0].particular,
        pesoSuperior: formCircuito.pesoSuperior,
        pesoSuperiorCritico: false,
        rec: 0, //harcodeado en angularionic
        sectorTurno,
        tipoiva: user.auth.data.paciente.tipoiva,
        videoAtencion: false, //lo lleno por con el checkbox
      };
    } else if (leyendaCircuito === "TOMO") {
      dtoTomo = {
        amamantando: formCircuito.amamantando,
        conContraste: formCircuito.conContraste, ////lo obtengo de seleccionar el item especialidad o estudio
        contrasteReciente: formCircuito.contrasteReciente,
        diabeticoHipertenso: formCircuito.diabeticoHipertenso,
        embarazada: formCircuito.embarazada,
        fechaDesde: onChangeDate !== null ? onChangeDate : fechaDeHoy, //fecha esta en datepicker
        GruposMedico: grupoMed,
        idGrupoMedico: grupoMed[0].id, //lo obtengo de seleccionar el item especialidad o estudio
        idObraSocial: user.auth.data.paciente.obra_social,
        idPlan: user.auth.data.paciente.idplan,
        insRenal: formCircuito.insRenal,
        marcapasos: false,
        operador: accion ? "BOT" : "",
        minutosGrupo: data ? data.minutos : 0,
        pag: 1200, //hardcodeado en angular
        particular: grupoMed[0].particular,
        pesoSuperior: formCircuito.pesoSuperior,
        pesoSuperiorCritico: formCircuito.pesoSuperiorCritico,
        rec: 0, //harcodeado en angularionic
        sectorTurno,
        tipoiva: user.auth.data.paciente.tipoiva,
        videoAtencion: false, //lo lleno por con el checkbox
      };
    } else {
      dtoCircuito = {
        amamantando: false,
        conContraste: false, ////lo obtengo de seleccionar el item especialidad o estudio
        contrasteReciente: false,
        diabeticoHipertenso: false,
        embarazada: false,
        fechaDesde: onChangeDate !== null ? onChangeDate : fechaDeHoy, //fecha esta en datepicker
        GruposMedico: grupoMed,
        idGrupoMedico: grupoMed[0].id, //lo obtengo de seleccionar el item especialidad o estudio
        idObraSocial: user.auth.data.paciente.obra_social, //lo obtengo del usuario
        idPlan: user.auth.data.paciente.idplan, // y aca
        insRenal: false,
        marcapasos: false,
        operador: accion ? "BOT" : "",
        minutosGrupo: data ? data.minutos : 0,
        pag: 1200, //hardcodeado en angular
        particular: grupoMed[0].particular,
        pesoSuperior: false,
        pesoSuperiorCritico: false,
        rec: 0, //harcodeado en angularionic
        sectorTurno,
        tipoiva: user.auth.data.paciente.tipoiva,
        videoAtencion: false, //lo lleno por con el checkbox
      };
    }
    editaTurnosDisponibles({
      ...turnosDisponiblesState.turnosDisponibles.turnosData,
      GruposMedico: grupoMed,
      idEstudio: grupoMed[0].id,
      descEstudio: grupoMed[0].descripcion,
    })(turnosDisponiblesDispatch);

    let dtoBusq = dtoReso ? dtoReso : dtoTomo ? dtoTomo : dtoCircuito;
    dtoPOST = dtoBusq;

    if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      wsPostTurnosEstudios(
        dtoBusq,
        selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
        (isCorrect, data) =>
          verificarEstudio(isCorrect, data, idEstudio, descEstudio)
      )(estudioTurnosDispatch);
    } else {
      wsPostTurnosEstudios(dtoBusq, -1, (isCorrect, data) =>
        verificarEstudio(isCorrect, data, idEstudio, descEstudio)
      )(estudioTurnosDispatch);
    }
    logoutEstudiosTurnos()(estudioTurnosDispatch);
  };

  const modalTurnosPresentismo = () => {
    if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      wsGetPresentismoDetalle(
        false,
        selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id
      )(presentismoDispatch);
    } else {
      wsGetPresentismoDetalle(false, false)(presentismoDispatch);
    }
  };

  const modalInfoPresentismo = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: <p className="rb24b">Información</p>,
        textoNegrita: (
          <p
            className="rb18l explicacionPresentismoEstudios"
            dangerouslySetInnerHTML={{
              __html:
                textosState?.textos?.data?.msjPresentismoAyuda?.descripcion,
            }}
          ></p>
        ),
        dissmiss: dissmiss,
      },
      [
        {
          text: "Aceptar",
          clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
          accion: dissmiss,
        },
      ],
      "centro",
      true
    )(modalDispatch);
  };
  //#endregion ----- functions --------

  //#region  ----------- useEffect ---------------
  // crear un useEffect para poder setear el user
  useEffect(() => {
    if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      // es el paciente completo
      setUser({
        auth: {
          data: selectDropDownState.selectDropDown.selectGlobal.pacienteElegido,
        },
      });
    } else {
      setUser(authState);
    }
  }, [selectDropDownState.selectDropDown.selectGlobal.pacienteElegido]);

  useEffect(() => {
    // Tengo que hacerlo en un useEffect porque de lo contrario
    // no realiza la busqueda.
    if (flgOrden) {
      if (ordenDigitalState.ordenDigital.grupoMed.length > 1) {
        if (
          ordenDigitalState.ordenDigital.grupoMed.length ===
          ordenesAgregadas.length
        ) {
          onBuscarTurnosClick();
        } else {
          setFlgOrden(false);
          // Revisar, capaz poner un index en lugar de ordenesAgregadas.length
          onChangeBuscador(
            ordenDigitalState.ordenDigital.grupoMed[ordenesAgregadas.length]
          );
        }
      } else {
        onBuscarTurnosClick();
      }
    }
  }, [flgOrden]);

  useEffect(() => {
    if (flgDobleVerif) {
      setFlgDobleVerif(false);
      if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
        //si es acepte que sea particular vuelvo a verificar, pero esta vez como particular.
        wsGetVerificaEstudios(
          idEstudio,
          true,
          false,
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
          OSAlternativa ? OSAlternativa : false,
          verificarEstudio
        )(estudioTurnosDispatch);
      } else {
        wsGetVerificaEstudios(
          idEstudio,
          true,
          false,
          -1,
          OSAlternativa ? OSAlternativa : false,
          verificarEstudio
        )(estudioTurnosDispatch);
      }
    }
  }, [flgDobleVerif]);

  useEffect(() => {
    if (
      flgPushTurnosDisp &&
      turnosDisponiblesState?.turnosDisponibles?.turnosData?.turnos
    ) {
      setLoading(false);
      history.push("/turnosDisponibles");
      setFlgPushTurnosDisp(false);
    }
  }, [flgPushTurnosDisp, turnosDisponiblesState.turnosDisponibles.turnosData]);

  useEffect(() => {
    if (estudioGrupoState.estudioGrupo.data !== null) {
      const arrGrupoMed = estudioGrupoState.estudioGrupo.data.filter(
        (item) => item.sonPracticas === true && item.id > 0
      );
      let filtCantidad = arrGrupoMed.sort((a, b) => {
        return b.cantBusquedas - a.cantBusquedas;
      });
      setDeterminaciones(filtCantidad);
      setFechaDeHoy(fechaTurnoFormat());
    }
    //agregue este reset para tener siempre los filtros a cero
    resetFiltrosDisponibles()(turnosDisponiblesDispatch);
  }, []);

  useEffect(() => {
    if (presentismoState.presentismo.data !== null) {
      showModal(
        "Turnos/ModalPresentismo/ModalPresentismo",
        {
          dissmiss: dissmiss,
          danger: true,
        },
        [],
        "centro",
        true
      )(modalDispatch);
    }
  }, [presentismoState.presentismo.data]);

  useEffect(() => {
    if (
      ordenDigitalState.ordenDigital.grupoMed !== null &&
      ordenDigitalState.ordenDigital.altaTurno !== null &&
      determinaciones &&
      !ordenGrupoMedProcessed.current
    ) {
      ordenGrupoMedProcessed.current = true;
      onChangeBuscador(ordenDigitalState.ordenDigital.grupoMed[0]);
    }
  }, [
    ordenDigitalState.ordenDigital.grupoMed,
    ordenDigitalState.ordenDigital.altaTurno,
    determinaciones,
  ]);
  //#endregion  -------- useEffect ---------------

  return (
    <React.Fragment>
      {!buscadorTurnos && (
        <>
          <div className="ptur-buscadorEstudio-desktop-dropdown">
            <Dropdown
              valor={
                listaFamiliaresState.listaFamiliares.loading &&
                (listaFamiliaresState.listaFamiliares.data === null ||
                  listaFamiliaresState.listaFamiliares.data === "")
                  ? ""
                  : !selectDropDownState.selectDropDown.selectGlobal
                      .pacienteElegido
                  ? authState.auth.data.paciente.codigo
                  : selectDropDownState.selectDropDown.selectGlobal
                      .pacienteElegido.id
              }
              datos={dropdownFamiliares(
                listaFamiliaresState,
                authState,
                "ManejoTurnos"
              )}
              campoCodigo="id"
              descripcion="nombre"
              onChange={onChangeMultitabMobile}
              placeholder={
                listaFamiliaresState.listaFamiliares.loading &&
                (listaFamiliaresState.listaFamiliares.data === null ||
                  listaFamiliaresState.listaFamiliares.data === "")
                  ? "Cargando Familiares..."
                  : ""
              }
              desactivado={
                listaFamiliaresState.listaFamiliares.loading &&
                (listaFamiliaresState.listaFamiliares.data === null ||
                  listaFamiliaresState.listaFamiliares.data === "")
                  ? true
                  : false
              }
              heightLista={"auto"}
              customCss={"widthDropdownBuscadorEstudios"}
            />
            {bloqueoPresentismo && (
              <PresentismoBox
                consultas={false}
                modalInfoPresentismo={modalInfoPresentismo}
                modalTurnosPresentismo={modalTurnosPresentismo}
              />
            )}
          </div>

          {bloqueoPresentismo && (
            <div className="ptur-buscadorEstudio-presentismoMobile">
              <PresentismoBox
                consultas={false}
                modalInfoPresentismo={modalInfoPresentismo}
                modalTurnosPresentismo={modalTurnosPresentismo}
              />
            </div>
          )}
        </>
      )}

      <div
        className={
          buscadorTurnos
            ? "ptur-cuerpoPestania-estudioBuscadorTurno"
            : "ptur-cuerpoPestania-estudio"
        }
      >
        <div
          className={
            buscadorTurnos
              ? "ptur-buscadorTurnos-dropdown-estudio"
              : "ptur-buscador-dropdown-estudio"
          }
        >
          {Array.isArray(gruposMedico) && gruposMedico.length > 0 && (
            <div className="ptur-estudio-informacionBuscador-desktop">
              <InformacionBuscador
                onClick={showInfoBuscador}
                leyendaCircuito={leyendaCircuito}
              />
            </div>
          )}
          <DropdownV2 config={configDropdown} onClick={onChangeBuscador} />
        </div>
        <div
          className={
            buscadorTurnos
              ? "ptur-buscadorTurnos-fechaBoton-container"
              : "ptur-buscador-fechaBoton-container"
          }
        >
          <div
            className={
              buscadorTurnos
                ? "ptur-buscadorTurno-fecha-estudio"
                : "ptur-buscador-fecha-estudio"
            }
          >
            <DatePicker
              fechaInicial={`${hoyDia.getFullYear()} ${
                hoyDia.getMonth() + 1
              } ${hoyDia.getDate()}`}
              fechaFinal={`${noventaDiasDespues.getFullYear()} ${
                noventaDiasDespues.getMonth() + 1
              } ${noventaDiasDespues.getDate()}`}
              headerStr={"Buscar fecha"}
              headerStrColor={buscadorTurnos && "c-white"}
              // fechaMin={hoy}
              onChange={onChangeDatePicker}
              customCss={
                buscadorTurnos
                  ? "ptur-datePickerBuscadorTurnos-estudios"
                  : "ptur-datePicker-estudios"
              }
            />
          </div>
          <div
            className={
              buscadorTurnos
                ? "ptur-buscadorTurnos-boton-estudio"
                : "ptur-buscador-boton-estudio"
            }
          >
            <button
              onClick={onBuscarTurnosClick}
              className={`${
                buscadorTurnos
                  ? "ptur-btn-buscadorTurnos-estudio"
                  : "ptur-btn-buscador-estudio"
              } bgc-primary c-white rb18m`}
              disabled={estudioTurnosState.estudioTurnos.loading}
            >
              {estudioTurnosState.estudioTurnos.loading ? (
                <span className="ptur-buscadorEstudio-loading">
                  <IonSpinner name="lines-small" />
                </span>
              ) : (
                "Siguiente"
              )}
            </button>
          </div>
        </div>
      </div>
      {Array.isArray(gruposMedico) && gruposMedico.length > 0 && (
        <>
          <div className="ptur-estudio-informacionBuscador-mobile">
            <InformacionBuscador
              onClick={showInfoBuscador}
              leyendaCircuito={leyendaCircuito}
            />
          </div>
          <TurnosAgregados
            onClickHandlerCancelarEtiq={onClickHandlerCancelarEtiq}
            gruposMedico={gruposMedico}
            buscadorTurnos={buscadorTurnos}
          />
        </>
      )}
    </React.Fragment>
  );
};

export default BuscadorEstudio2;
